import { createFileRoute } from "@tanstack/react-router";
import { CompanyInformationSettingsPage } from "../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/company-information")({
  component: CompanyInformationSettingsPage,
});
